﻿import * as React from "react";
import axios from "axios";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { IBaseSubSectionProps } from "../SubSections";
import { IToolProps } from "../Tool";

export interface IReleaseNotesSectionProps extends IBaseSectionProps {
    bindToolToFrame: (
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    functionCall: string;
    subSections: IBaseSubSectionProps[];
}

export const ReleaseNotesSection: React.FunctionComponent<
    IReleaseNotesSectionProps
> = (props): React.ReactElement => {
    const [unreadCount, setUnreadCount] = React.useState(0);

    // Get the unread release notes every 60 seconds
    React.useEffect(() => {
        updateUnreadMessages();
        const interval = setInterval(() => {
            updateUnreadMessages();
        }, 60000);

        return (): void => clearInterval(interval);
    }, []);

    const updateUnreadMessages = (): void => {
        // Get count of unread release notes
        axios
            .get(`${ROOT_URL}ReleaseNotes/GetUnreadCount`, {})
            .then((response) => {
                setUnreadCount(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const bindOnClick = (): void => {
        const activeProps: IActiveSectionProps = {
                moduleID: props.moduleID,
                sectionType: props.sectionType,
                tower: {
                    bindComponent: null,
                },
            },
            tool: IToolProps = props.subSections[0].tools[0];

        // Toggle the section
        props.toggleSection(activeProps, activeSectionsComparer);

        props.bindToolToFrame(
            tool.moduleID,
            tool.name,
            tool.lookupName,
            tool.url,
        );
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            const sectionType = activeSections[i].sectionType;

            if (
                sectionType === `MyProfile` ||
                sectionType === `ToolMenu` ||
                sectionType === `Notifications` ||
                sectionType === `ReleaseNotes` ||
                sectionType === `DataFeedStatus` ||
                sectionType === `EditProfile`
            ) {
                activeSections.splice(i, 1);
                i--;
            }
        }
        return activeSections;
    };

    const isActiveCSS: string = props.isActive ? `selected` : ``;

    return (
        <div className={`tab-section ${isActiveCSS}`} onClick={bindOnClick}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />

            {unreadCount > 0 && (
                <div className={`section-counterball Information`}>
                    {unreadCount}
                </div>
            )}
        </div>
    );
};
